// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"125":"96dbc88e","132":"9dcd7197","209":"73fd57c5","334":"a9b26108","453":"0098adef","944":"bfcba60a"}[chunkId] + ".chunk.js";
};